module.exports = __webpack_public_path__ + "img/icon_5_30.5ee0f06e.png";